module.exports = __webpack_public_path__ + "img/logo-dark.390bf675.webp";